module.exports = __webpack_public_path__ + "media/logos/above-the-law-logo-white-c20dfb6a.png";